"use client";

import { type ContentSectionCarousel_Fields } from "~/__generated__/graphql";
import ContentSection from "./ContentSection";
import { useState } from "react";
import { cn } from "~/utils/cn";

export default function ContentSectionCarousel({
  sections,
}: ContentSectionCarousel_Fields) {
  const [activeSectionIndex, setActiveSectionIndex] = useState(0);
  const activeSection = sections?.[activeSectionIndex];
  const backgroundColor = activeSection?.backgroundColor;

  return (
    <section
      className={cn(
        "px-6 py-10 lg:px-24 xl:px-48",
        backgroundColor?.[0] === "White"
          ? "bg-white"
          : backgroundColor?.[0] === "Blue"
          ? "bg-black"
          : backgroundColor?.[0] === "Grey"
          ? "bg-grey"
          : "bg-white",
      )}
    >
      <ContentSection className="!p-0" {...activeSection} />
      <div
        className={cn(
          "mt-4 flex items-center sm:m-0",
          backgroundColor?.[0] === "Blue" && "text-white",
        )}
      >
        <div className="w-10">
          {activeSectionIndex + 1}/{sections?.length}
        </div>
        <button
          className={cn(
            "material-icons-round mr-1",
            activeSectionIndex + 1 === 1 && "opacity-50",
          )}
          disabled={activeSectionIndex + 1 === 1}
          onClick={() => setActiveSectionIndex((prev) => prev - 1)}
        >
          arrow_back
        </button>
        <button
          className={cn(
            "material-icons-round",
            activeSectionIndex + 1 === sections?.length && "opacity-50",
          )}
          disabled={activeSectionIndex + 1 === sections?.length}
          onClick={() => setActiveSectionIndex((prev) => prev + 1)}
        >
          arrow_forward
        </button>
      </div>
    </section>
  );
}
